<form
  *ngIf="attributesForm"
  [formGroup]="attributesForm"
  [ngClass]="{ 'attributes-form': true, 'team-attributes-form': onTeamForm }"
>
  <div fxLayout="column">
    <div *ngFor="let attribute of formPage.editableAttributes" [ngSwitch]="attribute.type">
      <div *ngIf="attribute.isVisible && !attribute.isHidden && !attribute.isReadOnly" class="attribute-row">
        <label class="input-label" id="{{ attribute.attributeDefinitionId }}">
          <span
            [ngClass]="isModal ? 'modal-field-name' : ''"
            [innerHTML]="(useAttributeDescription ? attribute.description : attribute.name) | safeHtml"
          ></span>
          <span *ngIf="attribute.required" class="required-question" aria-label="This is a required field"> *</span>
        </label>
        <div>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [fxFlex]="fxFlexWidth"
            class="short-answer-field"
            *ngSwitchCase="shortAnswerAttributeUiType"
          >
            <input
              matInput
              type="text"
              formControlName="{{ attribute.attributeDefinitionId }}"
              placeholder="{{ attribute.required ? 'Required' : '' }}"
              (blur)="assignValueToAttribute(attribute)"
              attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
              (change)="onFieldChanged(attribute.attributeDefinitionId)"
            />
            <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty')">
              {{ attributesForm.get(attribute.attributeDefinitionId).getError('notEmpty') }}
            </mat-error>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [fxFlex]="fxFlexWidth"
            class="short-answer-field"
            *ngSwitchCase="encryptedFieldAttributeUiType"
          >
            <div fxLayout="row">
              <input
                matInput
                type="text"
                formControlName="{{ attribute.attributeDefinitionId }}"
                placeholder="{{ attribute.required ? 'Required' : '' }}"
                (blur)="assignValueToAttribute(attribute)"
                attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
                (change)="onFieldChanged('{{ attribute.attributeDefinitionId }}')"
              />
              <button
                *ngIf="
                  attribute.value && (attributesForm.get(attribute.attributeDefinitionId).value | base64UrlEncoded)
                "
                appThrottleClick
                mat-icon-button
                matTooltip="Show value"
                matTooltipPosition="before"
                (click)="togglePasswordVisibility(attribute)"
              >
                <mat-icon class="edit-icon mat-icon material-icons md-18">visibility</mat-icon>
              </button>
              <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty')">
                {{ attributesForm.get(attribute.attributeDefinitionId).getError('notEmpty') }}
              </mat-error>
            </div>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="number-field"
            *ngSwitchCase="numberAttributeUiType"
          >
            <input
              matInput
              type="number"
              min="{{ getAttributeDefinitionById(attribute.attributeDefinitionId).min }}"
              max="{{ getAttributeDefinitionById(attribute.attributeDefinitionId).max }}"
              formControlName="{{ attribute.attributeDefinitionId }}"
              placeholder="{{ attribute.required ? 'Required' : '' }}"
              (blur)="assignValueToAttribute(attribute)"
              attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
              (change)="onFieldChanged(attribute.attributeDefinitionId)"
            />
            <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('numberRange')">
              {{ attributesForm.get(attribute.attributeDefinitionId).getError('numberRange') }}
            </mat-error>
            <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty')">
              {{ attributesForm.get(attribute.attributeDefinitionId).getError('notEmpty') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="date-field"
            *ngSwitchCase="dateAttributeUiType"
          >
            <input
              matInput
              [matDatepicker]="picker"
              [formControlName]="attribute.attributeDefinitionId"
              [placeholder]="attribute.required ? 'Required' : ''"
              (dateChange)="assignValueToAttribute(attribute); onFieldChanged(attribute.attributeDefinitionId)"
              attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('invaliddate')">
              {{ attribute.name }} must be a valid date in mm/dd/yyyy format.
            </mat-error>
            <mat-error
              *ngIf="
                attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty') &&
                !attributesForm.get(attribute.attributeDefinitionId).hasError('matDatepickerParse')
              "
            >
              {{ attributesForm.get(attribute.attributeDefinitionId).getError('notEmpty') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <div role="listbox" attr.aria-labelledby="{{ attribute.attributeDefinitionId }}">
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              [fxFlex]="fxFlexWidth"
              class="dropdown-field"
              *ngSwitchCase="dropDownAttributeUiType"
            >
              <mat-select
                placeholder="{{ attribute.required ? 'Required' : 'None selected' }}"
                [formControlName]="attribute.attributeDefinitionId"
                (selectionChange)="assignValueToAttribute(attribute); onFieldChanged(attribute.attributeDefinitionId)"
                [compareWith]="dropDownAttributeDefinitionValueListItemComparer"
                [attr.aria-describedby]="attribute.attributeDefinitionId"
              >
                <mat-option>None selected</mat-option>
                <mat-option
                  class="attribute-editor-style"
                  *ngFor="let valueListItem of getAttributeValueList(attribute)"
                  [value]="valueListItem"
                >
                  {{ valueListItem.itemValue }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty')">
                {{ attributesForm.get(attribute.attributeDefinitionId).getError('notEmpty') }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div *ngSwitchCase="dateRangeUiType">
          <daterange
            [isTouched]="isAttributeTouched(attribute)"
            [fieldValue]="attribute.value"
            [required]="attribute.required"
            [placeholder]="attribute.required ? 'Required' : ''"
            [errorMessage]="attribute.name + ' is required'"
            [ariaLabelledby]="attribute.attributeDefinitionId"
            (dateChanged)="dateRangeChanged(attribute, $event); onFieldChanged(attribute.attributeDefinitionId)"
            [ariaLabelledby]="attribute.attributeDefinitionId"
          ></daterange>
        </div>
        <div *ngSwitchCase="longAnswerAttributeUiType">
          <rich-text-editor
            [form]="attributesForm"
            [field]="attribute.attributeDefinitionId"
            [fieldName]="attribute.name"
            [placeholder]="attribute.required ? 'Required' : ''"
            (textChanged)="longAnswerChanged(attribute, $event); onFieldChanged(attribute.attributeDefinitionId)"
          ></rich-text-editor>
        </div>
        <div
          class="checkbox-container"
          attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
          *ngSwitchCase="checkboxAttributeUiType"
          [formArrayName]="attribute.attributeDefinitionId"
          [ngClass]="
            attributesForm.get(attribute.attributeDefinitionId).value.touched &&
            attributesForm.get(attribute.attributeDefinitionId).hasError('notEmpty')
              ? 'checkbox-error'
              : 'checkbox-text'
          "
          role="group"
          attr.aria-labelledby="{{ attribute.attributeDefinitionId }}"
          (change)="onFieldChanged(attribute.attributeDefinitionId)"
        >
          <div class="checkbox-required-text">
            <div *ngIf="attribute.required">Required</div>
          </div>
          <div class="checkbox-item" *ngFor="let valueListItem of getAttributeValueList(attribute)">
            <mat-checkbox
              class="checkbox-text"
              color="primary"
              (change)="
                updateCheckboxAttributeDefinition(attribute, valueListItem, $event);
                onFieldChanged(attribute.attributeDefinitionId)
              "
              [checked]="getCheckboxStatus(attribute, valueListItem)"
              [disabled]="attribute.isReadOnly"
            >
              {{ valueListItem.itemValue }}
            </mat-checkbox>
            <div
              *ngIf="useAttributeDescription"
              [class.less]="valueListItem['show']"
              class="checkbox-item-container"
              [innerHtml]="valueListItem?.itemDescription | safeHtml"
            ></div>
            <button
              mat-button
              color="primary"
              *ngIf="useAttributeDescription && isDisplayed(valueListItem.itemDescription)"
              (click)="valueListItem['show'] = !valueListItem['show']"
              class="checkbox-more-less"
            >
              {{ valueListItem['show'] ? 'Show Less' : 'Show More' }}
              <mat-icon>{{ valueListItem['show'] ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
        </div>
        <div *ngSwitchCase="multiSelectAttributeUiType">
          <multiselect
            [isTouched]="isAttributeTouched(attribute)"
            [items]="getMultiselectValueList(attribute)"
            [filterMode]="false"
            (selectionChanged)="multiSelectChanged(attribute, $event)"
            (change)="onFieldChanged(attribute.attributeDefinitionId)"
            [required]="attribute.required"
            [errorMessage]="attribute.name + ' is required'"
            [placeholder]="'Please select...'"
            [ariaLabelledby]="attribute.attributeDefinitionId"
          ></multiselect>
        </div>
        <div *ngSwitchCase="skillAttributeUiType">
          <skill
            [required]="attribute.required"
            [isTouched]="isAttributeTouched(attribute)"
            [editMode]="true"
            [skillLevels]="getAttributeValueList(attribute)"
            [selectedSkillLevel]="attribute.attributeDefinitionValueListItem"
            [errorMessage]="attribute.name + ' is required'"
            (selectedChanged)="skillChanged(attribute, $event)"
            (change)="onFieldChanged(attribute.attributeDefinitionId)"
            [ariaLabelledby]="attribute.attributeDefinitionId"
            [title]="useAttributeDescription ? attribute.description : attribute.name"
          ></skill>
        </div>
        <div *ngSwitchCase="starRatingAttributeUiType">
          <app-star-rating-attribute
            [editMode]="true"
            [starRatings]="getAttributeValueList(attribute)"
            [selectedStarRating]="attribute.attributeDefinitionValueListItem"
            (selectedChanged)="skillChanged(attribute, $event); onFieldChanged(attribute.attributeDefinitionId)"
          ></app-star-rating-attribute>
        </div>
        <div *ngSwitchCase="documentUiType">
          <app-custom-document-uploader
            [mode]="mode"
            [uploadPath]="getUploadPath(attribute)"
            (uploadedFilesChanged)="
              customDocumentUploaderChanged(attribute, $event); onFieldChanged(attribute.attributeDefinitionId)
            "
            (uploadStatusChanged)="isUploading = $event"
            [errorMessage]="attribute.name + ' is required'"
            [required]="attribute.required"
            [isTouched]="isAttributeTouched(attribute)"
            [previouslyUploadedFiles]="attribute.value"
            [entityId]="entityId"
            (downLoadFile)="onDownloadFile($event, attribute)"
          ></app-custom-document-uploader>
        </div>
        <div fxLayout="column" *ngSwitchCase="complexUiType">
          <button
            [disabled]="attributeComplex(attribute)"
            fxFlex="100"
            mat-stroked-button
            color="primary"
            class="add-complex-button"
            (click)="onAddComplexValue(attribute)"
          >
            <mat-icon>add</mat-icon> ADD NEW {{ attribute.name.toLocaleUpperCase() }}
          </button>

          <div *ngFor="let complexAttributeValue of attribute.complexAttributeValues" class="editable-complex-value">
            <div class="complex-buttons">
              <button (click)="onEditComplexValue(attribute, complexAttributeValue)" mat-icon-button>
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="onDeleteComplexValue(attribute, complexAttributeValue)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

            <app-complex-field-viewer [complexAttributeValue]="complexAttributeValue"></app-complex-field-viewer>
          </div>
          <mat-error
            class="complex-error"
            *ngIf="attributesForm.get(attribute.attributeDefinitionId).hasError('complexRange')"
          >
            {{ attributesForm.get(attribute.attributeDefinitionId).getError('complexRange') }}
          </mat-error>
        </div>
      </div>
      <div
        *ngIf="attribute.isVisible && attribute.isReadOnly && attribute.hasValue() && !attribute.isHidden"
        class="attribute-row readonly"
      >
        <label class="input-label readonly">
          <span [innerHTML]="(useAttributeDescription ? attribute.description : attribute.name) | safeHtml"></span>
          <div *ngSwitchCase="skillAttributeUiType">
            <skill
              [editMode]="false"
              [skillLevels]="getAttributeValueList(attribute)"
              [selectedSkillLevel]="attribute.attributeDefinitionValueListItem"
              [ariaLabelledby]="attribute.attributeDefinitionId"
              [title]="useAttributeDescription ? attribute.description : attribute.name"
            ></skill>
          </div>
          <div *ngSwitchCase="starRatingAttributeUiType">
            <app-star-rating-attribute
              [editMode]="false"
              [starRatings]="getAttributeValueList(attribute)"
              [selectedStarRating]="attribute.attributeDefinitionValueListItem"
            ></app-star-rating-attribute>
          </div>
          <div *ngSwitchCase="documentUiType">
            <app-custom-document-uploader
              [readOnly]="attribute.isReadOnly"
              [mode]="mode"
              (downLoadFile)="onDownloadFile($event, attribute)"
              [previouslyUploadedFiles]="attribute.value"
              [entityId]="entityId"
            ></app-custom-document-uploader>
          </div>
          <div *ngSwitchCase="complexUiType">
            <div *ngFor="let complexAttributeValue of attribute.complexAttributeValues" class="editable-complex-value">
              <app-complex-field-viewer [complexAttributeValue]="complexAttributeValue"></app-complex-field-viewer>
            </div>
          </div>
          <div *ngSwitchDefault>
            <p
              class="readonly-value"
              *ngFor="let value of attribute.valueList"
              [innerHTML]="value.itemValue | safeHtml"
            ></p>
            <p class="readonly-value" *ngIf="attribute.value" [innerHTML]="attribute.value | safeHtml"></p>
          </div>
        </label>
      </div>
    </div>
  </div>
</form>
